import { apiUrlNode } from "../../shared/constants";

export const apiUrl = apiUrlNode;